import { useCallback } from 'react';

const className = 'scroll-lock';

export const useScrollLock = () => {
  const lockPageScroll = useCallback(() => {
    const html = document.querySelector('html')!;
    if (!html || html.classList.contains(className)) {
      return;
    }
    html.classList.add(className);
  }, []);

  const unlockPageScroll = useCallback(() => {
    const html = document.querySelector('html')!;
    if (!html || !html.classList.contains(className)) {
      return;
    }
    html.classList.remove(className);
  }, []);

  return {
    lockPageScroll,
    unlockPageScroll,
  };
};
